

































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import axios from 'axios'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import SaveButton from '@/components/SaveButton.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import PhoneNumber from '@/components/PhoneNumber.vue'
import capitalCase from '@/functions/capitalCase'
import { Company, CompanyCollection, User, UserCollection, UserRoleEnum, UserStatusEnum } from 'serverless-firestore'
import store, {Actions} from '../../store'

@Component({
  components: { LoadingPage, SaveButton, PhoneNumber }
})
export default class UserEdit extends Mixins(IconsMixin, AuthMixin) {
  public userDetails: User | null = null
  public action: 'create' | 'modify' | '' = ''
  public roles = this.generateItems(UserRoleEnum).filter(r => r.value !== UserRoleEnum.ADMIN)
  public isSaving: boolean = false
  public error: string = ''
  public userRole: UserRoleEnum | null = null;
  public showConfirmModal = false
  public showErrorModal = false
  public errorModalMessage = ''
  public loadingPhoneNumber = false
  public phoneNumberFound = false

  public $refs!: {
    form: HTMLFormElement
  }

  public async mounted() {
    try {
      if (this.$route.params.id === 'create') {
        this.action = 'create'
        this.userDetails = this.createNewUser()
      } else {
        this.action = 'modify'
        this.userDetails = await this.lookupExistingUser(this.$route.params.id)

        if(!this.userDetails) {
          const err = new Error('You do not have permissions to view that page')
          return store.dispatch(Actions.SET_ERROR, [err, this.$router])
        }

        this.userRole = this.userCompany.userRoles[this.userDetails.id]
      }
    } catch (error) {
      const err = new Error('You do not have permissions to view that page')
      return store.dispatch(Actions.SET_ERROR, [err, this.$router])
    }
  }

  public async save() {
    const isValid = this.$refs.form.validate()
    if (!isValid || !this.userDetails) {
      return
    }

    this.isSaving = true

    let user: {id: string}
    try {
      if (this.userDetails.id && this.action === 'modify') {
        const {name, email} = this.userDetails;
        user = (await axios.put(
          `/api/restaurants/${this.userCompany.id}/users/${this.userDetails.id}`,
          { name, email, role: this.userRole }
        )).data;
      } else {
        if (this.userRole) {
          this.userDetails.companyRoles = { [this.userCompany.id]: this.userRole }
        }
        user = (await axios.post(
          `/api/restaurants/${this.userCompany.id}/users`,
          { ...this.userDetails, role: this.userRole }
        )).data
      }
    } catch (err) {
      let errMessage
      if (err.response && err.response.data && err.response.data.message) {
        errMessage = err.response.data.message
      } else if (err.message) {
        errMessage = err.message
      } else {
        errMessage = 'An error has occured while saving the user.'
      }
      this.isSaving = false
      this.error = errMessage
      return
    }
    store.dispatch(Actions.ADD_USER_TO_COMPANY, [user.id, this.userRole])

    this.isSaving = false
    this.error = ''
    await this.$router.push({ name: 'user-list' })
  }

  @Watch('userDetails.phoneNumber')
  public async lookupPhoneNumber() {
    if(!this.userDetails || !/^\+\d+[0-9]{3}[0-9]{3}[0-9]{4}$/.test(this.userDetails.phoneNumber)) {
      this.phoneNumberFound = false
      return
    }

    this.loadingPhoneNumber = true

    const userCollection = new UserCollection(( await this.$firebase ).firestore())
    const user = await userCollection.getUserByPhone(this.userDetails.phoneNumber)

    if(!user) {
      this.phoneNumberFound = false
    } else {
      this.phoneNumberFound = true
      this.userDetails = user
    }

    this.loadingPhoneNumber = false
  }

  public confirmRemove() {
    this.showConfirmModal = false
    this.removeUser()
  }

  public async removeUser() {
    if (!this.userDetails) {
      return
    }

    try {
      await axios.delete(`/api/restaurants/${this.userCompany.id}/users/${this.userDetails.id}`)
      this.$router.replace({ name: 'user-list' })
    } catch (err) {
      this.errorModalMessage = err.message
      this.showErrorModal = true
    }
  }

  private createNewUser() {
    return new User('', this.userCompany.id, '')
  }

  private async lookupExistingUser(id: string) {
    const collection = new UserCollection(( await this.$firebase ).firestore())
    const user = await collection.getUser(this.$route.params.id)
    if (!user) {
      return null
    }

    return user
  }

  private generateItems(enumSet: {[key: string]: string}) {
    return Object.values(enumSet).map((v) => (
      {
        text: capitalCase(v),
        value: v
      }
    ))
  }
}
